import React from "react";
import { Helmet } from "react-helmet-async";

export interface BreadcrumbItem {
  name: string;
  url?: string;
}

interface BreadcrumbSchemaProps {
  items: BreadcrumbItem[];
}

/**
 * Компонент для добавления микроразметки Schema.org BreadcrumbList
 * Невидим для пользователей, используется только для SEO (Яндекс, Google)
 */
export const BreadcrumbSchema: React.FC<BreadcrumbSchemaProps> = ({ items }) => {
  // Генерируем Schema.org BreadcrumbList в формате JSON-LD
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      // Добавляем URL только если он указан (для всех кроме последнего элемента)
      ...(item.url && { item: `https://polotno.tech${item.url}` })
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
    </Helmet>
  );
};
